// move to module later

export const isValidCPF = (document: string): boolean => {
  if (typeof document !== 'string') {
    return false;
  }

  // eslint-disable-next-line no-param-reassign
  document = document.replace(/[^\d]+/g, '');

  if (document.length !== 11 || !!document.match(/(\d)\1{10}/)) {
    return false;
  }

  const cpf = document.split('').map(el => +el);

  const rest = (count: number) =>
    ((cpf
      .slice(0, count - 12)
      .reduce((soma, el, index) => soma + el * (count - index), 0) *
      10) %
      11) %
    10;

  return rest(10) === cpf[9] && rest(11) === cpf[10];
};
